const getQueryWithPagination = (props) => {
    return {
        ...props,
        offset: 0,
        limit: 20,
    };
};
export default getQueryWithPagination;
